import { render, staticRenderFns } from "./DraftOrdersDataTable.vue?vue&type=template&id=37f65e84&scoped=true"
import script from "./DraftOrdersDataTable.vue?vue&type=script&lang=js"
export * from "./DraftOrdersDataTable.vue?vue&type=script&lang=js"
import style0 from "./DraftOrdersDataTable.vue?vue&type=style&index=0&id=37f65e84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f65e84",
  null
  
)

export default component.exports